export default function PageNotFound() {
  return (
    <section>
      <h2>Seite nicht gefunden</h2>
      <p>Die angeforderte Seite existiert nicht.</p>
    </section>
  );
}
